<template>
  <div class="gameplan">
    <ContentHeader path-set-type="append" :gameplan-nav="true" />
    <div class="content-wrapper" v-loading="loading">
      <el-row>
        <el-col :span="6" class="content-left">
          <div class="menu-container">
            <el-card class="trade-nav-panel trade-nav-panel-sp"  v-if="employeeLevel>=45&&employeeLevel<90">
              <div slot="header" class="clearfix">
                <div class="panel-header">我参与的活动</div>
              </div>
              <el-menu @select="clickMenu" :default-active="themeChannelCode" class="sp_el_menu" active-text-color="#101010" text-color="#101010">
                <el-menu-item index="01">
                  <span slot="title">执行中</span>
                </el-menu-item>
                <el-menu-item index="06">
                  <span slot="title">已结束</span>
                </el-menu-item>
              </el-menu>
            </el-card>
            <el-card class="trade-nav-panel trade-nav-panel-sp" v-if="employeeLevel>=45">
              <div slot="header" class="clearfix">
                <span class="panel-header">我发起的活动</span>
              </div>
              <el-menu @select="clickMenu" :default-active="themeChannelCode" active-text-color="#101010" text-color="#101010">
                <el-menu-item index="04">
                  <span slot="title">待提交</span>
                </el-menu-item>
                <el-menu-item index="03">
                  <span slot="title">执行中</span>
                </el-menu-item>
                <el-menu-item index="05">
                  <span slot="title">已结束</span>
                </el-menu-item>
              </el-menu>
            </el-card>

            <el-card class="trade-nav-panel margin-top-20" v-if="employeeLevel>=45">
              <el-menu @select="clickMenu" :default-active="themeChannelCode" class="sp_el_menu" active-text-color="#101010" text-color="#101010">
                <el-menu-item index="02" @click="handleUnConfig()">
                  <span slot="title">待配置</span>
                </el-menu-item>
              </el-menu>
            </el-card>

          </div>
        </el-col>
        <el-col :span="18" class="content-right">
          <div v-if="themeChannelCode!=='02'">
            <div class="search">
              <el-form :inline="true" :model="queryParams" ref="searchForm" class="searchForm">
                <el-form-item class="item" prop="prNumber">
                  <el-input v-model="queryParams.prNumber" placeholder="PR编码" size="small" clearable/>
                </el-form-item>
                <el-form-item class="item" prop="prName">
                  <el-input v-model="queryParams.prName" placeholder="PR名称" size="small" clearable/>
                </el-form-item>
                <el-form-item class="item" prop="themeName">
                  <el-input v-model="queryParams.themeName" placeholder="活动名称"  size="small" clearable/>
                </el-form-item>
                <el-form-item class="item" prop="brandCode">
                  <el-select v-model="queryParams.brandCode" placeholder="选择品牌" size="small" clearable>
                    <el-option v-for="item in btmpBrandDTOList" :key="item.brandCode" :label="item.brandDisplayName" :value="item.brandCode">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="item" prop="themeChannelScope" v-if="themeChannelCode!=='02'">
                  <el-select v-model="queryParams.themeChannelScope" placeholder="选择渠道" size="small" clearable>
                    <el-option v-for="item in gpThemeChannelMap" :key="item.key" :label="item.value" :value="item.key">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="item-btn">
                  <el-button type="danger" size="small" @click="getGameplanThemeList(1,10)">搜索</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="info" size="small" @click="resetForm()">重置</el-button>
                </el-form-item>
              </el-form>
            </div>
            <div v-if="themeList.length>0">
              <div class="normal_box margin_bottom_20 is_hover_shadow" v-for="item of themeList" :key="item.themeId">
                  <div class="pr_item">
                    <div class="pr_item_left">
                      <div class="pr_title">
                        {{item.themeName}}
                      </div>
                      <div class="pr_info">
                        <div class="pr_info_item">PR编码：{{item.gpPrDTO&&item.gpPrDTO.prNumber}}</div>
                        <div class="pr_info_item">PR名称：{{item.gpPrDTO&&item.gpPrDTO.prName}}</div>
                      </div>
                      <div class="pr_info">
                        <div class="pr_info_brand color_blue">{{item.gpPrDTO&&item.gpPrDTO.brandName}}  {{(item.gpPrDTO&&item.gpPrDTO.brandName&&item.gpPrDTO.subBrandName)?'-':''}} {{item.gpPrDTO&&item.gpPrDTO.subBrandName}}</div>
                        <div class="pr_info_brand color_yellow">{{getThemeChannels(item.themeChannels)}}</div>
                      </div>
                      <div class="pr_date">{{ item.themeStartTime | parseTime("{y}-{m}-{d}") }} {{item.themeStartTime?'-':''}}  {{ item.themeEndTime | parseTime("{y}-{m}-{d}") }} </div>
                    </div>
                    <div class="pr_item_right">
                      <div class="pr_status">{{getThemeStatus(item.themeStatus)}}</div>
                      <div class="pr_operation_btn_box" v-if="toConfigure(item.themeStatus)||item.assignStatus">
                        <div class="pr_operate_btn" @click="gotoWeb('activity-configure',item.themeId,item)">{{isOwner?'继续配置':'额度分配'}}</div>
                      </div>
                      <div class="pr_operation_btn_box" v-else>
                        <!-- <div class="pr_operate_btn_white" v-if="isOwner(item.themeOwnerCode)" @click="handleSOW(item.themeId)">推送活动需求</div> -->
                        <div class="pr_operate_btn_white" @click="gotoDetail(item.themeId)">活动详情</div>
                        <div class="pr_operate_btn_blue" v-if="(isOwner(item.themeOwnerCode)&&item.themeStatus!==500&&item.themeStatus!==900)" @click="gotoWeb('PO-connect',item.themeId)">关联PO</div>
                      </div>
                    </div>
                  </div>
              </div>
              <div class="pagination">
                <el-pagination background :total="total" layout="total, prev, pager, next" :current-page="queryParams.page"
                  :page-size="queryParams.pageSize" @current-change="handleCurrentChange" @size-change="handleSizeChange" />
              </div>
            </div>
            <div v-else class="margin_bottom_20 no-data">暂无数据</div>
          </div>
          <div v-else>
            <ActivityManagementUnConfiguredItem/>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { mapGetters,mapState } from 'vuex'
import gameplanApi from "@/api/gameplan";
import ContentHeader from '@/components/content-header'
import ActivityManagementUnConfiguredItem from './components/activity-management-un-configured-item.vue';
export default {
  name: 'activity-management',
  components: {
    ContentHeader,
    ActivityManagementUnConfiguredItem
  },
  data() {
    return {
      themeList:[],
      total: 0,
      queryParams: {
        page: 1,
        pageSize: 10,
        queryCondition:'',
        prNumber: '', // PR编码
        prName:'', // PR名称
        themeName: '', // 活动名称
        brandCode: '', // 选择品牌
        themeChannelScope: '', // 选择渠道
      },
      btmpBrandDTOList:[],
      themeLit:[
        {}
      ],
      employeeLevel:'',
      loading:false,
      prList:[],
      themeChannelMap:[],
      themeChannelCode:'01'
    }
  },
  // watch:{
  //   '$route' (){
  //     if(this.$route.params.activityType==='02'&&this.employeeLevel>=90){
  //       this.gotoWeb('activity-management-un-configured')
  //       return
  //     }else if(this.$route.params.activityType==='02'&&this.employeeLevel>=60&&this.employeeLevel<90){
  //       this.getGameplanThemeUnconfiguredList()
  //       return
  //     }else {
  //       this.queryParams.queryCondition = this.$route.params.activityType
  //       this.getGameplanThemeList()
  //       return
  //     }
  //   }
  // },
  computed: {
    ...mapGetters(['userInfo']),
    ...mapState({
      gpThemeChannelMap:state=> state.base.gpThemeChannelMap,
    }),
    isHQ(){
      return this.employeeLevel>=90
    },
  },
  created() {
    this.$store.dispatch('getDictByName','gpThemeChannelMap')
    this.employeeLevel = this.userInfo.employeeLevel
    if(this.employeeLevel>=90){
      this.themeChannelCode='03'
    }
    if(this.$route.params.activityType==='02'){
      this.getGameplanThemeUnconfiguredList()
    }else {
      this.queryParams.queryCondition = this.themeChannelCode
      this.getGameplanThemeList()
      this.getGamepalnBrandquery()
    }
  },
  methods: {
    isBU(){
      return this.employeeLevel>=60&&this.employeeLevel<90
    },
    isRegion(){
      return this.employeeLevel>=45&&this.employeeLevel<60
    },
    toConfigure(themeStatus){
      if(this.employeeLevel>=90){
        return themeStatus==0
      }else if(this.employeeLevel>=60&&this.employeeLevel<=90){
        return themeStatus==100 || themeStatus==0
      }else if(this.employeeLevel>=45&&this.employeeLevel<=60){
        return themeStatus==0
      }
      return true
    },
    isOwner(themeOwnerCode){
      return this.userInfo.employeeCode===themeOwnerCode
    },
    handleUnConfig(){
      // if(this.employeeLevel>=90){
        this.gotoWeb('activity-management-un-configured')
      // }else {
      //   this.getGameplanThemeUnconfiguredList()
      // }
    },
    clickMenu(index) {
      this.themeChannelCode = index;
      this.queryParams.queryCondition = index
      this.queryParams.page = 1;
      if(this.themeChannelCode==='02'){
        this.getGameplanThemeUnconfiguredList()
      }else {
        this.getGameplanThemeList();
      }
    },
    async getGameplanThemeList(page,pageSize) {
      page?this.queryParams.page=page:''
      pageSize?this.queryParams.pageSize=pageSize:''
      this.loading = true
      if(this.themeChannelCode==='02'){
        this.getGameplanThemeUnconfiguredList()
      }else {
        const { data } = await gameplanApi.getGameplanThemeList(this.queryParams);
        if (data.resultCode === "0") {
          this.themeList = data.resultData?.themeList || [];
          this.prList = []
          this.total = data.resultData.pageInfo.totalCounts
        }
        this.loading = false
      }
    },
    async getGameplanThemeUnconfiguredList() {
      let params ={
        page: this.queryParams.page,
        pageSize: this.queryParams.pageSize,
        prNumber: this.queryParams.prNumber, // PR编码
        prName:this.queryParams.prName, // PR名称
        brandCode:this.queryParams.brandCode, // 选择品牌
      }
      const { data } = await gameplanApi.getGameplanThemeUnconfiguredList(params);
      if (data.resultCode === "0") {
        console.log(data.resultData);
        this.prList =  data.resultData?.prList || [];
        this.themeList = []
        //this.total = data.resultData.pageInfo.totalCounts
      }
    },
    async getGameplanThemeApproveList() {
      const { data } = await gameplanApi.getGameplanThemeApproveList(this.queryParams);
      if (data.resultCode === "0") {
        this.themeList = data.resultData?.themeList || [];
        this.total = data.resultData.pageInfo.totalCounts
      }
    },
    async getGamepalnBrandquery() {
      const { data } = await gameplanApi.getGamepalnBrandquery(this.queryParams);
      if (data.resultCode === "0") {
        this.btmpBrandDTOList = data.resultData?.btmpBrandDTOList || [];
      }
    },
    // async getGameplanThemeUnconfiguredList() {
    //   const { data } = await gameplanApi.getGameplanThemeUnconfiguredList();
    //   if (data.resultCode === "0") {
    //   }
    // },
    handleSOW(themeId){
      this.$confirm('是否要推送活动需求?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        confirmButtonClass: 'btn-red',
        type: 'warning'
      }).then(async() => {
        const { data } = await gameplanApi.gameplanThemeDownload(themeId);
        if (data.resultCode === "0") {
          this.$alert('推送成功', '提示', {
            confirmButtonText: '确定',
            confirmButtonClass: 'btn-red',
          });
        }
      }).catch(() => {
      });
    },
    getThemeStatus(themeStatus){
      switch (themeStatus) {
        case 0:
          return '待提交'
        case 100:
          return '执行中'
        case 200:
          return '执行中'
        case 300:
          return '待提交'
        case 400:
          return '执行中'
        case 500:
          return '已结束'
        default:
          break;
      }
      return 0
    },
    getThemeChannels(themeChannels){
      let result = ''
      for(let item of themeChannels){
        result+=item.themeChannelEnName + '、'
      }
      return result.substr(0, result.length - 1);
    },
    handleCurrentChange(val) {
      this.queryParams.page = val
      this.getGameplanThemeList()
    },
    handleSizeChange (val) {
      this.queryParams.pageSize = val
      this.getGameplanThemeList()
    },
    submitForm(val) {

    },
    resetForm() {
      this.$refs.searchForm.resetFields();
      this.queryParams.page=1
      this.queryParams.pageSize=10
      this.getGameplanThemeList()
    },
    // 活动详情
    activityDetail() {
      this.$router.push({ path: '/gameplan/activity-detail/all', query: { prId: '1' } })
    },
    // 配置活动
    gotoWeb(name,themeId,item) {
      if(name==='activity-configure'){
        if(item.themeStatus===0){
          this.$router.push({ name:'activity-configure-hq' , query:{themeId,prName:item.gpPrDTO.prName,brand:item.gpPrDTO.brandName,subBrand:item.gpPrDTO.subBrandName,prNumber:item.gpPrDTO.prNumber}})
          return
        }
        if(this.employeeLevel>=90){
          this.$router.push({ name:'activity-configure-hq' , query:{themeId,prName:item.gpPrDTO.prName,brand:item.gpPrDTO.brandName,subBrand:item.gpPrDTO.subBrandName,prNumber:item.gpPrDTO.prNumber}})
          return
        }
      }
      this.$router.push({ name ,query:{themeId}})
    },
    gotoDetail(themeId){
      sessionStorage.setItem('themeId',themeId)
      this.$router.push({ path: '/gameplan/activity-management-detail/all' })
    },
    gotoConfig(prName,brandName,subBrandName,prNumber) {
      this.$router.push({ name:'activity-configure-hq' , query:{prName,brand:brandName,subBrand:subBrandName,prNumber}})
    },
    // 关联PO
    relevancePo() { }
  }
}
</script>
<style lang="scss" scoped>
.is-hover-shadow:hover {
  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.2);
}

.margin-top-20{
  margin-top: 30px !important;
}
.trade-nav-panel {
  width: 80%;
  margin: 0 auto;
  background: $base-white;

  //   .el-menu-item:last-child{
  //     border-bottom: 0;
  //   }
  ::v-deep .el-card__header {
    height: 70px;
    line-height: 35px;
  }

  ::v-deep .el-card__body {
    padding: 0;
  }

  .panel-header {
    font-size: 16px;
    font-weight: 700;
    color: #CD1231;
  }

  ::v-deep .el-menu {
    border-right: 0;
  }

  ::v-deep .el-menu-item {
    border-bottom: 1px solid $base-grey5;
  }

  ::v-deep .el-menu-item.is-active {
    color: $base-red;
  }
}
.menu-container{
  margin-top: -20px;
}
.content-wrapper {
  min-height: calc(100vh - 320px) !important;
  font-family: SourceHanSansSC-regular;
  //   .content-left,
  .content-right {
    height: 100%;
    box-sizing: border-box;
    a {
      text-decoration: none;
      color: #000;
    }

    .search {
      // margin-left: 60px;
      .searchForm {
        width: 100%;
        .item {
          width: 120px;
        }
        .item-btn {
          margin-left: 30px;
        }
      }
    }

    .pagination {
      position: relative;
      bottom: 0;
    }
  }
.pagination .el-pagination {
  text-align: center;
}
  .content-left {
    padding-right: $content-middle;
  }
}

.pr_item{
  ::v-deep .el-card__body{
      padding: 15px;
    }
}

.block{
  //margin-top: 20px;
  //background-color: rgba(0, 0, 0, 1);
  width: 100%;
  height: 30px;
}
.trade-nav-panel-sp{
  margin-top: 30px;
}
.no-data{
  text-align: center;
  padding: 100px 0;
}
</style>
